export default {
    REPORT: "fa-chart-bar",
    LAB: "fa-vial",
    PHARMACY: "fa-file-prescription",
    PATIENT: "fa-paw",
    BILLING: "fa-money-check-alt",
    SYSTEM: "fa-cog",
    SCHEDULE: "fa-calendar-alt",
    DIAGNOSTIC_IMAGE: "fa-x-ray",
    DOCUMENT: "fa-file-alt",
    PETCARE: "fa-mobile-alt"
};
